import React from "react";

import { createHashRouter } from "react-router-dom";
import DashboardRoute from "components/fragments/dashboard/components/DashboardRoute";
import DashboardTab from "components/fragments/dashboard/components/tab/DashboardTab";
import NotFound from "../error/NotFound";
import OtherPage from "./OtherPage";
import OtherPage2 from "./OtherPage2";
// eslint-disable-next-line import/no-cycle
import RouteList from "./RouteList";

import DevSandbox from "../../dashboard/dev-sandbox/DevSandbox";
import DatasetWindow from "../../dashboard/dataset-window";
import VikingMaltBestBatchCalculator from "../../company-specific/viking-malt/best-batch-calculator/VikingMaltBestBatchCalculator";
import EasasMainLayout from "./EasasMainLayout";
import ProjectDropDown from "../measurement-devices/components/ProjectDropDown";
import Layout from "../measurement-devices/components/Layout";
import Objects from "../measurement-devices/routes/Objects";
import NewObjectForm from "../measurement-devices/routes/NewObjectForm";
import EditObjectForm from "../measurement-devices/routes/EditObjectForm";
import Devices from "../measurement-devices/routes/Devices";
import EditDeviceForm from "../measurement-devices/routes/EditDeviceForm";
import NewDeviceForm from "../measurement-devices/routes/NewDeviceForm";
import Analytics from "../measurement-devices/routes/Analytics";
import Jobs from "../measurement-devices/routes/Jobs";
import ObjectMap from "../measurement-devices/routes/ObjectMap";
import SingleObjectMap from "../measurement-devices/routes/SingleObjectMap";
import Settings from "../measurement-devices/routes/Settings";
import ErrorPage from "../measurement-devices/routes/ErrorPage";
import MeasurementDevicesRoot from "../measurement-devices/MeasurementDevicesRoot";
import CompanyFilesPage from "../company-files/CompanyFilesPage";
import AuthorizationManagementPage from "../authorization-management/AuthorizationManagementPage";

const easasMainRouter = createHashRouter([
  {
    path: "/",
    element: <EasasMainLayout />,
    children: [
      { index: true, element: <RouteList /> },
      { path: "/sandbox", element: <DevSandbox /> },
      { path: "/files", element: <CompanyFilesPage /> },
      { path: "/auth-management", element: <AuthorizationManagementPage /> },
      { path: "/datasets", element: <DatasetWindow /> },
      { path: "/instant-job-run", element: <VikingMaltBestBatchCalculator /> },
      {
        path: "/dashboard/:dashboardId",
        element: <DashboardRoute />,
        children: [{ path: "tab/:tabId", element: <DashboardTab /> }],
      },
      {
        path: "/mdm",
        element: <MeasurementDevicesRoot />,
        children: [
          { path: "", element: <ProjectDropDown /> },
          {
            path: ":projectId",
            element: <Layout />,
            children: [
              { index: true, element: <Objects /> },
              { path: "objects/new", element: <NewObjectForm /> },
              { path: "objects/:objectId", element: <EditObjectForm /> },
              { path: "devices", element: <Devices /> },
              { path: "devices/:deviceId", element: <EditDeviceForm /> },
              { path: "devices/new", element: <NewDeviceForm /> },
              { path: "analytics", element: <Analytics /> },
              { path: "jobs", element: <Jobs /> },
              { path: "map", element: <ObjectMap /> },
              { path: "map/:objectId", element: <SingleObjectMap /> },
              { path: "settings", element: <Settings /> },
              { path: "*", element: <ErrorPage msg="Page not found" /> },
            ],
          },
        ],
      },
      {
        path: "/other-page",
        element: <OtherPage />,
        children: [
          {
            path: ":pageId",
            element: <OtherPage2 />,
          },
        ],
      },
      { path: "/other-page-2/:pageId", element: <OtherPage2 /> },
      { path: "/*", element: <NotFound /> },
    ],
  },
]);
export default easasMainRouter;
export const { routes } = easasMainRouter;
